import { render } from "./bank.vue?vue&type=template&id=edce24b8&scoped=true"
import script from "./bank.vue?vue&type=script&lang=js"
export * from "./bank.vue?vue&type=script&lang=js"

import "./bank.vue?vue&type=style&index=0&id=edce24b8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-edce24b8"]])

export default __exports__